import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-access-restricted',
  templateUrl: './access-restricted.component.html',
  styleUrls: ['./access-restricted.component.scss'],
})
export class AccessRestrictedComponent  implements OnInit {
  errorCode: string = '429'; // Default error code

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    // Get error code from query parameters
    this.route.queryParams.subscribe(params => {
      if (params['errorCode']) {
        this.errorCode = params['errorCode'] === '0' ? '429' : params['errorCode'];
      }
    });
  }

}
